<template>
  <div class="tip-container">
    <svg width="122" height="122" viewBox="0 0 122 122" xmlns="http://www.w3.org/2000/svg">
      <path d="M60.9998 10.1667C32.9398 10.1667 10.1665 32.9401 10.1665 61.0001C10.1665 89.0601 32.9398 111.833 60.9998 111.833C89.0598 111.833 111.833 89.0601 111.833 61.0001C111.833 32.9401 89.0598 10.1667 60.9998 10.1667ZM60.9998 86.4168C58.204 86.4168 55.9165 84.1293 55.9165 81.3334V61.0001C55.9165 58.2042 58.204 55.9167 60.9998 55.9167C63.7957 55.9167 66.0832 58.2042 66.0832 61.0001V81.3334C66.0832 84.1293 63.7957 86.4168 60.9998 86.4168ZM66.0832 45.7501H55.9165V35.5834H66.0832V45.7501Z"/>
    </svg>
    <span>
      <!-- TODO добавить перевод -->
      Apply {{ data.applications }} tanks
      of {{ parseFloat($store.getters['unit/convert']('L', data.volume)) }} {{$store.getters['unit/getLabel']('L')}}
      <template v-if="stage">
        during {{ stage }} days
      </template>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    data: {}
  },
  computed: {

    stage() {
      return this.$store.getters['program/fertigation/getStage']();
    }
  },
}
</script>

<style lang="scss" scoped>

.tip-container {
  display: flex;
  flex-direction: row;
  align-items: center;

  border-radius: 5px;
  // border: 1px solid $mainGreen;
  padding: 10px;
  margin-bottom: 20px;

  svg {
    width: 20px;
    height: auto;
    fill: #aaa;
  }

  span {
    font-size: 14px;
    font-weight: 500;
    margin-left: 10px;
    color: #aaa;
  }
}

</style>
